<template>
    <CustomTopSheetDialog v-model="show" :width="900" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{$t('shop.createStream.heading')}}
            </h3>
            <v-divider></v-divider>
        </template>

        <template #default>
            <p>
                {{$t('shop.createStream.text')}}
            </p>
            <p v-html="$t('shop.createStream.text2')">

            </p>
            <v-tabs class="create-news-tabs" mandatory="true" grow v-model="tab" hide-slider="true"
                selected-class="v-tab-selected" density="compact">
                <v-tab :text="$t('shop.createStream.nav.product')" :value="'product'" variant="text" :ripple="false" size="x-large">

                </v-tab>
                <v-tab :text="$t('shop.createStream.nav.event')" :value="'event'" variant="text" :ripple="false" size="x-large">

                </v-tab>
                <v-tab :text="$t('shop.createStream.nav.news')" :value="'news'" variant="text" :ripple="false" size="x-large">

                </v-tab>
            </v-tabs>
            <v-tabs-window v-model="tab">
                <v-tabs-window-item :value="'product'" class="pa-4">
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label class="mr-4">{{$t('global.form.headline')}}</v-label>
                        </v-col>
                        <v-col class="d-inline-flex align-items-center">
                            <v-text-field v-model="localItem.headline" variant="outlined" density="compact"
                                :hide-details="true">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label class="mr-4">{{$t('global.form.description')}}</v-label>
                        </v-col>
                        <v-col class="align-items-center">
                            <v-textarea v-model="localItem.text" class="shop-description-input" no-resize
                                :hide-details="true" density="compact" variant="outlined" rows="6">
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label class="mr-4">{{$t('global.form.new-product.shop-link')}}</v-label>
                        </v-col>
                        <v-col class="d-inline-flex align-items-center">
                            <v-text-field v-model="localItem.onlineShopUrl" variant="outlined" density="compact"
                                placeholder="https://www.meineonlineshops.de/beispiel" :hide-details="true">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label class="mr-4">{{$t('global.form.new-product.product')}}</v-label>
                        </v-col>
                        <v-col class="d-inline-flex align-items-center">
                            <v-autocomplete v-model="selectedProducts" @update:search="onSearchProducts"
                                variant="outlined" density="compact" :hide-details="true" :items="filteredProducts"
                                item-title="name" return-object item-value="id" chips closable-chips multiple
                                no-data-text="nichts ausgewählt" :placeholder="$t('global.form.new-product.search')">
                                <template v-slot:chip="{ item }">
                                    <v-chip label variant="flat" color="primary">
                                        {{ item.title }}
                                    </v-chip>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label class="mr-4">{{$t('global.form.new-product.brand')}}</v-label>
                        </v-col>
                        <v-col class="d-inline-flex align-items-center">
                            <v-autocomplete v-model="selectedBrands" @update:search="onSearchBrands" variant="outlined"
                                density="compact" :hide-details="true" :items="filteredBrands" item-title="name"
                                return-object chips closable-chips multiple item-value="id"
                                no-data-text="nichts ausgewählt" :placeholder="$t('global.form.new-product.brand-search')">
                                <template v-slot:chip="{ item }">
                                    <v-chip label variant="flat" color="primary">
                                        {{ item.title }}
                                    </v-chip>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label class="mr-4">{{$t('global.form.new-product.label')}}</v-label>
                        </v-col>
                        <v-col class="d-inline-flex align-items-center">
                            <v-autocomplete :multiple="true" v-model="selectedLabels" variant="outlined"
                                density="compact" :hide-details="true" :items="labels" item-title="name"
                                item-color="primary" item-value="id" return-object chips closable-chips
                                no-data-text="nichts ausgewählt" placeholder="Gütesiegel auswählen...">

                                <template v-slot:chip="{ item }">
                                    <v-chip label variant="flat" color="primary">
                                        {{ item.title }}
                                    </v-chip>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label class="mr-4">{{$t('global.form.new-product.publish')}}</v-label>
                        </v-col>
                        <template v-if="remainingProductStreams == 0">
                            <v-col sm="8"> 
                                <v-list-item tile variant="flat" base-color="primary" class="py-2" >
                                    <template v-slot:prepend>
                                        <v-icon color="white" icon="mdi-information"></v-icon>
                                    </template>
                                    {{$t('shop.stream.notInFeed.text')}}
                                </v-list-item>
                            </v-col>
                                
                            <v-col sm="4"></v-col>
                        </template>
                        <v-col class="d-inline-flex align-items-center">
                            <v-radio-group v-model="release">
                                <v-radio :label="$t('global.form.new-product.publish-now')" value="now"></v-radio>
                                <v-radio :label="$t('global.form.new-product.publish-later')" value="later"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-expand-transition>
                        <v-card v-show="showMinDate" class="" height="auto" variant="flat">
                            <v-row justify="center" align="center" class="">
                                <v-col sm="5" class="d-inline-flex align-items-center">
                                    <v-menu location="bottom" class="language-picker" :close-on-content-click="false">
                                        <template v-slot:activator="{ props }">
                                            <v-text-field v-bind="props" v-model="selectedMinDateFormatted"
                                                variant="outlined" density="compact" :hide-details="true"
                                                class="date-picker"
                                                :placeholder="`${selectedMinDate.getDate()}.${selectedMinDate.getMonth() + 1}.${selectedMinDate.getFullYear()}`">
                                                <template v-slot:append-inner>
                                                    <v-icon class="mx-2">mdi-calendar</v-icon>
                                                    <!-- <div color="default">
                                                    </div> -->
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="selectedMinDate"></v-date-picker>
                                    </v-menu>
                                </v-col>

                                <v-col sm="2" class="d-inline-flex align-items-center pr-0">
                                    <v-text-field type="number" maxlength="2" class="time-input mr-1"
                                        v-model="endTime.hours" variant="outlined" density="compact"
                                        :hide-details="true" :placeholder="`${selectedMinDate.getHours()}`"
                                        @blur="validateTimeInput('hours', endTime)">
                                    </v-text-field>
                                    <v-text-field type="number" maxlength="2" class="time-input"
                                        v-model="endTime.minutes" variant="outlined" density="compact"
                                        :hide-details="true" :placeholder="`${selectedMinDate.getMinutes()}`"
                                        @blur="validateTimeInput('minutes', endTime)">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-expand-transition>
                    <v-row justify="center" align="center" :class="{ 'mt-3': showMinDate }">
                        <v-col sm="4" class="text-right">
                            <v-label style="color:#D50000" v-if="productImageUploadError.show"> {{
                                productImageUploadError.msg }} </v-label>
                            <v-label class="mr-4">
                                {{$t('shop.createStream.images.label')}} <br>
                                {{$t('shop.createStream.resolution')}} <br>
                                {{$t('shop.createStream.pixels')}}
                            </v-label>
                        </v-col>
                        <v-col sm="3" class="d-inline-flex align-items-center justify-content-center">
                            <v-btn color="primary" variant="flat" size="x-small" rounded="lg" icon="mdi-plus"
                                @click="triggerproductImageInput"></v-btn>
                            <input type="file" accept="image/*" ref="productImageInput" style="display: none;"
                                @change="handleproductImageChange" />
                        </v-col>
                        <v-col sm="5" class="d-inline-flex align-items-center justify-content-center">
                            <v-row>
                                <v-col cols="12" lg="8" v-for="(i, index) in productImages" :key="index">
                                    <v-img class="pa-2" :src="`${proxy.$cloudFrontApi}${i.id}/STREAM`" width="140px">
                                        <v-icon color="error" class="float-right" @click.stop="() => removeImage(i.id)">
                                            mdi-trash-can
                                        </v-icon>
                                    </v-img>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-tabs-window-item>
                <v-tabs-window-item :value="'event'" class="pa-4">
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label class="mr-4">{{$t('global.form.headline')}}</v-label>
                        </v-col>
                        <v-col class="d-inline-flex align-items-center">
                            <v-text-field v-model="localItem.headline" variant="outlined" density="compact"
                                :hide-details="true">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label class="mr-4">{{$t('global.form.description')}}</v-label>
                        </v-col>
                        <v-col class="align-items-center">
                            <v-textarea v-model="localItem.text" class="shop-description-input" no-resize
                                :hide-details="true" density="compact" variant="outlined" rows="6">
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label class="mr-4">{{$t('global.form.new-product.start-date')}}</v-label>
                        </v-col>
                        <v-col sm="5" class="d-inline-flex align-items-center">
                            <v-menu location="bottom" class="language-picker" :close-on-content-click="false">
                                <template v-slot:activator="{ props }">
                                    <v-text-field v-bind="props" v-model="selectedStartDateFormatted" variant="outlined"
                                        density="compact" :hide-details="true" class="date-picker"
                                        :placeholder="`${selectedStartDate.getDate()}.${selectedStartDate.getMonth() + 1}.${selectedStartDate.getFullYear()}`">
                                        <template v-slot:append-inner>
                                            <v-icon class="mx-2">mdi-calendar</v-icon>
                                            <!-- <div color="default">
                                            </div> -->
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker v-model="selectedStartDate"></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col class="d-inline-flex align-items-center pr-0">
                            <v-text-field type="number" maxlength="2" class="time-input mr-1" v-model="startTime.hours"
                                variant="outlined" density="compact" :hide-details="true"
                                :placeholder="`${selectedStartDate.getHours()}`"
                                @blur="validateTimeInput('hours', startTime)">
                            </v-text-field>
                            <v-text-field type="number" maxlength="2" class="time-input" v-model="startTime.minutes"
                                variant="outlined" density="compact" :hide-details="true"
                                :placeholder="`${selectedStartDate.getMinutes()}`"
                                @blur="validateTimeInput('minutes', startTime)">
                            </v-text-field>
                        </v-col>
                        <v-spacer>

                        </v-spacer>
                    </v-row>
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label class="mr-4">{{$t('global.form.new-product.end-date')}}</v-label>
                        </v-col>
                        <v-col sm="5" class="d-inline-flex align-items-center">
                            <v-menu location="bottom" class="language-picker" :close-on-content-click="false">
                                <template v-slot:activator="{ props }">
                                    <v-text-field v-bind="props" v-model="selectedEndDateFormatted" variant="outlined"
                                        density="compact" :hide-details="true" class="date-picker"
                                        :placeholder="`${selectedEndDate.getDate()}.${selectedEndDate.getMonth() + 6}.${selectedEndDate.getFullYear()}`">
                                        <template v-slot:append-inner>
                                            <v-icon class="mx-2">mdi-calendar</v-icon>
                                            <!-- <div color="default">
                                            </div> -->
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker v-model="selectedEndDate"></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col class="d-inline-flex align-items-center pr-0">
                            <v-text-field type="number" maxlength="2" class="time-input mr-1" v-model="endTime.hours"
                                variant="outlined" density="compact" :hide-details="true"
                                :placeholder="`${selectedEndDate.getHours()}`"
                                @blur="validateTimeInput('hours', endTime)">
                            </v-text-field>
                            <v-text-field type="number" maxlength="2" class="time-input" v-model="endTime.minutes"
                                variant="outlined" density="compact" :hide-details="true"
                                :placeholder="`${selectedEndDate.getMinutes()}`"
                                @blur="validateTimeInput('minutes', endTime)">
                            </v-text-field>
                        </v-col>
                        <v-spacer>

                        </v-spacer>
                    </v-row>
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label class="mr-4">{{$t('shop.createStream.images.label-single')}}</v-label>
                            <!-- {{ selectedImage.src }} -->
                        </v-col>
                        <v-col sm="8" class="align-items-center px-5">
                            <cropper :aspectRatio="16 / 9" ref="cropper" class="cropper mb-2" :src="selectedImage.src"
                                v-if="selectedImage.src && image == null" :stencil-props="{
                                    aspectRatio: 16 / 9,
                                    movable: true,
                                    resizable: true
                                }" />
                            <v-img v-else-if="image != null" aspect-ratio="16/9" cover class="mb-2"
                                :src="image"></v-img>
                            <v-img v-else aspect-ratio="16/9" cover class="mb-2"
                                :style="{ backgroundColor: 'rgb(var(--v-theme-default))', height: '246px' }"></v-img>
                            <v-btn class="float-right" size="large" variant="flat" color="primary" rounded="xl"
                                @click="cropImage" v-if="selectedImage.src">Zuschneiden</v-btn>
                            <v-btn class="float-right" size="large" variant="outlined" rounded="0"
                                @click="triggerFileSelect" v-if="!selectedImage.src">{{$t('global.form.new-product.choose-image')}}</v-btn>
                            <v-btn class="float-right" size="large" variant="flat" color="default" rounded="xl"
                                @click="resetImage" v-else>{{ $t('entity.action.cancel') }}</v-btn>
                            <!-- Hidden file input -->
                            <input type="file" accept="image/*" ref="fileInput" style="display: none;"
                                @change="handleFileChange" />
                        </v-col>
                    </v-row>
                </v-tabs-window-item>
                <v-tabs-window-item :value="'news'" class="pa-4">
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label class="mr-4">{{$t('global.form.headline')}}</v-label>
                        </v-col>
                        <v-col class="d-inline-flex align-items-center">
                            <v-text-field v-model="localItem.headline" variant="outlined" density="compact"
                                :hide-details="true">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label class="mr-4">{{$t('global.form.description')}}</v-label>
                        </v-col>
                        <v-col class="align-items-center">
                            <v-textarea v-model="localItem.text" class="shop-description-input" no-resize
                                :hide-details="true" density="compact" variant="outlined" rows="6">
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label class="mr-4">{{$t('global.form.new-product.publish')}}</v-label>
                        </v-col>
                        <template v-if="remainingNewsStreams == 0">
                            <v-col sm="8"> 
                                <v-list-item tile variant="flat" base-color="primary" class="py-2" >
                                    <template v-slot:prepend>
                                        <v-icon color="white" icon="mdi-information"></v-icon>
                                    </template>
                                    {{$t('shop.stream.notInFeed.text')}}
                                </v-list-item>
                            </v-col>
                                
                            <v-col sm="4"></v-col>
                        </template>
                        <v-col class="d-inline-flex align-items-center">
                            <v-radio-group v-model="release">
                                <v-radio :label="$t('global.form.new-product.publish-now')" value="now"></v-radio>
                                <v-radio :label="$t('global.form.new-product.publish-later')" value="later"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-expand-transition>
                        <v-card v-show="showMinDate" class="" height="auto" variant="flat">
                            <v-row justify="center" align="center" class="">
                                <v-col sm="5" class="d-inline-flex align-items-center">
                                    <v-menu location="bottom" class="language-picker" :close-on-content-click="false">
                                        <template v-slot:activator="{ props }">
                                            <v-text-field v-bind="props" v-model="selectedMinDateFormatted"
                                                variant="outlined" density="compact" :hide-details="true"
                                                class="date-picker"
                                                :placeholder="`${selectedMinDate.getDate()}.${selectedMinDate.getMonth() + 1}.${selectedMinDate.getFullYear()}`">
                                                <template v-slot:append-inner>
                                                    <v-icon class="mx-2">mdi-calendar</v-icon>
                                                    <!-- <div color="default">
                                                    </div> -->
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="selectedMinDate"></v-date-picker>
                                    </v-menu>
                                </v-col>

                                <v-col sm="2" class="d-inline-flex align-items-center pr-0">
                                    <v-text-field type="number" maxlength="2" class="time-input mr-1"
                                        v-model="endTime.hours" variant="outlined" density="compact"
                                        :hide-details="true" :placeholder="`${selectedMinDate.getHours()}`"
                                        @blur="validateTimeInput('hours', endTime)">
                                    </v-text-field>
                                    <v-text-field type="number" maxlength="2" class="time-input"
                                        v-model="endTime.minutes" variant="outlined" density="compact"
                                        :hide-details="true" :placeholder="`${selectedMinDate.getMinutes()}`"
                                        @blur="validateTimeInput('minutes', endTime)">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-expand-transition>
                    <v-row justify="center" align="center" class="">
                        <v-col sm="4" class="text-right">
                            <v-label style="color:#D50000" v-if="productImageUploadError.show"> {{
                                productImageUploadError.msg }}
                            </v-label>
                            <v-label class="mr-4">
                                {{$t('shop.createStream.images.label')}} <br>
                                {{$t('shop.createStream.resolution')}} <br>
                                {{$t('shop.createStream.pixels')}}
                            </v-label>
                        </v-col>
                        <v-col sm="3" class="d-inline-flex align-items-center justify-content-center">
                            <v-btn color="primary" variant="flat" size="x-small" rounded="lg" icon="mdi-plus"
                                @click="triggerproductImageInput"></v-btn>
                            <input type="file" accept="image/*" ref="productImageInput" style="display: none;"
                                @change="handleproductImageChange" />
                        </v-col>
                        <v-col sm="5" class="d-inline-flex align-items-center justify-content-center">
                            <v-row>
                                <v-col cols="12" lg="8" v-for="(image, index) in productImages" :key="index">
                                    <v-img class="pa-2" :src="`${proxy.$cloudFrontApi}${image.id}/STREAM`"
                                        width="140px">
                                        <v-icon color="error" class="float-right" @click="() => removeImage(image.id)">
                                            mdi-trash-can
                                        </v-icon>
                                    </v-img>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-tabs-window-item>
            </v-tabs-window>
            <p class="text-right">{{$t('global.form.new-product.app-label')}} <a target="_blank"
                    href="https://apps.apple.com/de/app/findeling-f%C3%BCr-ladenbesitzer/id1033194004">iOS</a> {{$t('global.form.new-product.and')}} <a
                    target="_blank"
                    href="https://play.google.com/store/apps/details?id=de.findeling.findelshop">Android</a> </p>
        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="releaseNews">{{ $t('global.form.new-product.publish') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
import EmojiPicker from 'vue3-emoji-picker';
import 'vue3-emoji-picker/css'
import { CircleStencil, Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
export default {
    name: "CreateShopNewsDialog",
    components: {
        EmojiPicker,
        Cropper, CircleStencil
    },
    // props: {
    //     modelValue: {
    //         type: Boolean,
    //         required: true,
    //     },
    // },
    // computed: {
    //     show: {
    //         get() {
    //             return this.modelValue;
    //         },
    //         set(value) {
    //             this.$emit("update:modelValue", value);
    //         },
    //     },


    // },


    methods: {
        validateTimeInput(type, timeObject) {
            // Ensure input is numeric and limit to a maximum of 2 digits
            if (type === 'hours') {
                timeObject.hours = timeObject.hours.replace(/\D/g, '').slice(0, 2); // Remove non-numeric and limit to 2 digits
                if (timeObject.hours.length === 1) {
                    timeObject.hours = `0${timeObject.hours}`; // Add leading zero if only one digit
                }
            }
            if (type === 'minutes') {
                timeObject.minutes = timeObject.minutes.replace(/\D/g, '').slice(0, 2); // Remove non-numeric and limit to 2 digits
                if (timeObject.minutes.length === 1) {
                    timeObject.minutes = `0${timeObject.minutes}`; // Add leading zero if only one digit
                }
            }
        },
        getCroppedData() {
            const { coordinates, canvas, } = this.$refs.cropper.getResult();
            return { coordinates, canvas, }
        }
    },
};
</script>
<script setup>
import { ref, inject, onMounted,onUpdated, computed, watch, getCurrentInstance, defineProps, defineEmits, defineModel } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';
import CustomEmojiPicker from '@/components/custom/CustomEmojiPicker.vue';

const props = defineProps({
    item: {
        type: Object,
        required: true
    }
})


// const emit = defineEmits(['update:modelValue'])

const show = defineModel();

const closeSheet = () => {
    show.value = false;
    localItem.value = {}
    productImages.value = []
};


const localItem = ref(null);
const tab = ref('product')



const originalShop = inject('shop');
// const  = ref(Object.assign({}, orignalShop.value));
const shop = ref({ ...originalShop.value });

const release = ref('now');
const selectedStartDate = ref(new Date());
const selectedStartDateFormatted = ref('');
const selectedEndDate = ref(new Date());
const selectedEndDateFormatted = ref('');
const selectedMinDate = ref(new Date());
const selectedMinDateFormatted = ref('');
const image = ref(null);
const { proxy } = getCurrentInstance();
const productImages = ref([]);
const selectedLabels = ref([]);
const selectedProducts = ref([]);
const selectedBrands = ref([]);
const filteredProducts = ref([]);
const filteredBrands = ref([]);
const labels = ref([]);
const productImageUploadError = ref({
    show: false,
    msg: ""
})
const remainingProductStreams = ref(0);
const remainingNewsStreams = ref(0);

const startTime = ref({
    hours: '',
    minutes: '',
})
const endTime = ref({
    hours: '',
    minutes: '',
});

const hardToken = localStorage.getItem("hardToken");
const username = localStorage.getItem("username");
const softToken = localStorage.getItem("softToken");

// const newsObject = ref({
//     title: null,
//     description: null,
//     onlineShopUrl: null


// })


// Watch for prop changes and update the copy



const fileInput = ref(null);
const productImageInput = ref(null);

const selectedImage = ref({
    src: null,
    width: 80,
    height: 80,
    transforms: {
        rotate: 15,
        flip: {
            horizontal: true,
            vertical: false,
        },
    },
});

watch(
    () => props.item,
    (newItem) => {
        if (newItem) {
            localItem.value = { ...newItem }; // Create a copy for editing
            tab.value = newItem.category;
            image.value = `${proxy.$cloudFrontApi}${newItem.image}/STREAM`;
            productImages.value = newItem.images;
            // selectedStartDate.value = newItem.eventStartDate;
            const startdate = new Date(newItem.eventStartDate) || null;
            const enddate = new Date(newItem.eventEndDate) || null;
            enddate.is
            if (!isNaN(startdate) && !isNaN(enddate)) {
                selectedStartDateFormatted.value = `${String(startdate.getDate()).padStart(2, '0')}.${String(startdate.getMonth() + 1).padStart(2, '0')}.${startdate.getFullYear()}` || null;
                selectedEndDateFormatted.value = `${String(enddate.getDate()).padStart(2, '0')}.${String(enddate.getMonth() + 1).padStart(2, '0')}.${enddate.getFullYear()}` || null;
                startTime.value.hours = `${String(startdate.getHours()).padStart(2, '0')}` || null;
                startTime.value.minutes = `${String(startdate.getMinutes()).padStart(2, '0')}` || null;
                endTime.value.hours = `${String(enddate.getHours()).padStart(2, '0')}` || null;
                endTime.value.minutes = `${String(enddate.getMinutes()).padStart(2, '0')}` || null;
            }

        } else {

            localItem.value = { name: "", description: "", price: 0 }; // Default new item
            localItem.value = {}
            productImages.value = []
            selectedStartDateFormatted.value = ''
            selectedEndDateFormatted.value = ''
            startTime.value.hours = ''
            startTime.value.minutes = ''
            endTime.value.hours = ''
            endTime.value.minutes = ''
            image.value = null;
            productImages.value = [];
        }
    },
    { deep: true, immediate: true } // Runs immediately when component is mounted
);

watch(() => originalShop.value, (newShop) => {
    shop.value = { ...newShop }; // Create a fresh copy when the original shop changes
}, { deep: true });

watch(() => selectedStartDate.value, (newDate) => {
    const date = new Date(newDate);
    selectedStartDateFormatted.value = `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}`;
}, { deep: true });

watch(() => selectedEndDate.value, (newDate) => {
    const date = new Date(newDate);
    selectedEndDateFormatted.value = `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 5).padStart(2, '0')}.${date.getFullYear()}`;
}, { deep: true });

watch(show, (newVal) => {
  if (newVal) {
    fetchRemainings();
  }
})

const maxLength = 30;
// const remainingCharacters = ref(maxLength - shop.value.email);

const showMinDate = computed(() => {
    return release.value == "later";
});
const newsObject = computed(() => {
    return release.value == "later";
});

// var copy = Object.assign({}, orignalShop.value)
// const shop = ref(copy)

const insertEmoji = (emoji) => {
    const text = shop.value.tagline;
    const position = cursorPosition.value;
    shop.value.tagline = text.slice(0, position) + emoji.i + text.slice(position);
    cursorPosition.value += emoji.length; // Move the cursor forward
};

const fetchLabels = async () => {

    try {
        const response = await proxy.$axios.get("/public/data/labels", {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
        });

        if (response.data.status == "OK") {
            labels.value = response.data.data || [];
        }

    } catch (error) {
        console.error("Error fetching search results:", error);
        labels.value = [];
    } finally {
        // loading.value = false;
    }
};

const fetchRemainings = async () => {

    try {
        const response = await proxy.$axios.get("/stream/dealer/v2/remaining", {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
        });

        if (response.data.status == "OK") {
            remainingProductStreams.value = response.data.data.remainingProductStreams;
            remainingNewsStreams.value = response.data.data.remainingNewsStreams;
        }

    } catch (error) {
        console.error("Error fetching search results:", error);
        labels.value = [];
    } finally {
        // loading.value = false;
    }
};

const triggerFileSelect = () => {
    image.value = null;
    fileInput.value.click();
};

const cropImage = () => {
    const result = proxy.getCroppedData();
    image.value = result.canvas.toDataURL();
    resetImage();
}

const showImageUploadError = () => {
    productImageUploadError.value.show = true;
    productImageUploadError.value.msg = 'Bitte benutze ein Bild mit einer höheren Auflösung.';
}

const triggerproductImageInput = () => {
    productImageInput.value.click();
};

const handleproductImageChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const tempPic = new Image();
    const objectURL = URL.createObjectURL(file);

    tempPic.onload = async () => {
        console.log(`Image resolution: ${tempPic.width}x${tempPic.height}`);

        if (tempPic.width < 500 || tempPic.height < 500) {
            showImageUploadError();
            URL.revokeObjectURL(objectURL);
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await proxy.$axios.post('/image/stream', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-SOFTTOKEN': softToken,
                    'X-Auth-USER': username
                },
            });
            if (response.data && response.status == 200) {
                productImages.value.push({ id: response.data.data });
            }
        } catch (error) {
            console.error("Upload failed", error);
        } finally {
            URL.revokeObjectURL(objectURL);
        }
    };

    tempPic.src = objectURL;
};
const uploadedImageId = ref(null)

const handleFileChange = async (event) => {
  const file = event.target.files?.[0];
  if (!file) {
    fileInput.value.value = '';
    return;
  }

  const reader = new FileReader();
  reader.onload = async (e) => {
    const tempimage = new Image();
    tempimage.onload = async () => {
      // ✅ keep the preview
      selectedImage.value.src = e.target.result;

      // ✅ upload to /image/stream/event
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await proxy.$axios.post("/image/stream/event", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-Auth-HARDTOKEN": hardToken,
            "X-Auth-SOFTTOKEN": softToken,
            "X-Auth-USER": username,
          },
        });

        if (response?.status === 200 && response.data) {
          // optional: store returned id if you need it later
          // e.g. selectedImage.value.id = response.data.data;
          // or image.value = response.data.data;
          uploadedImageId.value =response.data.data
          console.log("Event image uploaded:", response.data.data);
        }
      } catch (error) {
        console.error("Event image upload failed:", error);
      }
    };

    tempimage.onerror = () => {
      console.error("Invalid image file.");
    };

    tempimage.src = e.target.result;
  };

  reader.readAsDataURL(file);

  // allow reselecting the same file
  fileInput.value.value = '';
};

const removeImage = (id) => {
    productImages.value = productImages.value.filter(img => img.id !== id);
}

const resetImage = () => {
    selectedImage.value = {
        src: null,
        width: 80,
        height: 80,
        transforms: {
            rotate: 15,
            flip: {
                horizontal: true,
                vertical: false,
            },
        },
    }
}


const onSearchBrands = async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) {
        filteredBrands.value = []; // Clear the items when input is empty
        return;
    }

    // loading.value = true;
    try {
        const response = await proxy.$axios.get("/public/data/brands/query", {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
            params: {
                keyword: searchTerm,
            },
        });

        // Update filteredItems with the API response
        filteredBrands.value = response.data.data || [];
    } catch (error) {
        console.error("Error fetching search results:", error);
        filteredBrands.value = [];
    } finally {
        // loading.value = false;
    }
};

const onSearchProducts = async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) {
        filteredProducts.value = []; // Clear the items when input is empty
        return;
    }

    // loading.value = true;
    try {
        const response = await proxy.$axios.get("/public/data/productgroups/query", {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
            params: {
                keyword: searchTerm,
            },
        });

        // Update filteredItems with the API response
        filteredProducts.value = response.data.data || [];
    } catch (error) {
        console.error("Error fetching search results:", error);
        filteredProducts.value = [];
    } finally {
        // loading.value = false;
    }
};

const releaseNews = async () => {
    const obj = {};
    obj.headline = localItem.value.headline;
    obj.text = localItem.value.text;
    if (tab.value == 'product') {

        obj.productUrl = localItem.value.onlineShopUrl;
        obj.productGroups = selectedProducts.value;
        obj.brands = selectedBrands.value;
        obj.labels = selectedLabels.value;
        obj.images = productImages.value;
        obj.category = tab.value;
        obj.publishedAt = release.value == 'now' ? null : selectedMinDateFormatted.value
    } else if (tab.value == 'event') {
        obj.eventStartDate = selectedStartDate.value;
        obj.eventEndDate = selectedEndDate.value;
        obj.images = [uploadedImageId.value];
        obj.category = tab.value;
    } else {
        obj.images = productImages.value.map(image => {
            return image.id;
        });
        obj.publishedAt = release.value == 'now' ? Date.parse(new Date()) : selectedMinDateFormatted.value
        obj.category = tab.value;
    }

    try {
        const response = await proxy.$axios.post("/stream/dealer", obj, {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
        });

        // Update filteredItems with the API response
        if (response.data.status == "OK") {
            closeSheet();
        }
    } catch (error) {
        console.error("Error fetching search results:", error);
        filteredProducts.value = [];
    } finally {
        // window.location.reload();
        // loading.value = false;
    }
}


const cursorPosition = ref(0); // Track cursor position
const inputRef = ref(null);

onMounted(() => {
    fetchLabels();
});

</script>

<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}

.v-col>.v-label {
    font-weight: 700;
    font-size: 14px;
}

.shop-description-input textarea,
.shop-info-container .v-field__input {
    font-size: 14px !important;
    font-weight: 300 !important;
}

.emoji-picker-container {
    width: 300px;
    /* Adjust width as needed */
    height: 400px;
    /* Adjust height as needed */
    overflow-y: auto;
    /* Add scroll if content overflows */
    padding: 8px;
}

.date-picker .v-field .v-field__append-inner {
    background-color: rgb(var(--v-theme-default)) !important;
}

.time-input .v-field__input {
    padding-right: 0px;
}

.create-news-tabs .v-tab {
    font-weight: 600 !important;
}
</style>

<style scoped>
.v-tab-selected {
    border: 1px solid #ddd !important;
    border-bottom: 0 !important;
}

.v-window-item--active {
    border-top: 0 !important;
    border: 1px solid #ddd !important;
}
</style>
